import * as React from 'react';
import ProjectsInfoModal from '../ProjectsInfoModal';
import useProfileUsageMetrics from '../../hooks/useProfileUsageMetrics';

function AutonomousAiUsage() {
  const { data, error, loading } = useProfileUsageMetrics();
  const usageMeter = data?.autonomous_ai_usage_meter;
  const bonus_insights     = usageMeter?.bonus_insights;
  const premium_insights   = usageMeter?.premium_insights;
  const executive_insights = usageMeter?.executive_insights;
  const user_plan = usageMeter?.user_plan;

  function insights_percentage(used, max) {
    if (!max || max === 0 || used === undefined || used === null) {
      return 0;
    }
    return Math.round((used / max) * 100);
  }

  return (
    <div className="py-4 border-bottom">
      <p className="clearfix">
        <div className="card">
          <div className="card-body">
            <h4 className="card-title"><strong>Autonomous AI Usage</strong></h4>
            <p className="page-description">Insights generated by Autonomous AI Agents. <ProjectsInfoModal message="Learn more" /></p>
            { loading ? (
              <div>Loading usage metrics...</div>
            ) : error || !bonus_insights ? (
              <div>Usage metrics are unavailable at the moment.</div>
            ) : (
              <div className="template-demo">
                <div className="d-flex justify-content-between">
                  <small>Autonomous AI Agents - bonus insights</small>
                  <small>{bonus_insights.used + '/' + bonus_insights.max}</small>
                </div>
                <div className="progress progress-lg mt-2">
                  <div className="progress-bar bg-danger" role="progressbar" style={{ 'width': insights_percentage(bonus_insights.used, bonus_insights.max) + '%'}}>{insights_percentage(bonus_insights.used, bonus_insights.max) + '%'}</div>
                </div>
                { user_plan == 'premium' && premium_insights ? (
                  <span>
                    <div className="d-flex justify-content-between mt-2">
                      <small>Autonomous AI Agents - premium insights (This month)</small>
                      <small>{premium_insights.used + '/' + premium_insights.max}</small>
                    </div>
                    <div className="progress progress-lg mt-2">
                      <div className="progress-bar bg-danger" role="progressbar" style={{ 'width': insights_percentage(premium_insights.used, premium_insights.max) + '%'}}>{insights_percentage(premium_insights.used, premium_insights.max) + '%'}</div>
                    </div>
                  </span>
                ) : null}
                { user_plan == 'executive' && executive_insights ? (
                  <span>
                    <div className="d-flex justify-content-between mt-2">
                      <small>Autonomous AI Agents - executive insights (This month)</small>
                      <small>{executive_insights.used + '/' + executive_insights.max}</small>
                    </div>
                    <div className="progress progress-lg mt-2">
                      <div className="progress-bar bg-danger" role="progressbar" style={{ 'width': insights_percentage(executive_insights.used, executive_insights.max) + '%'}}>{insights_percentage(executive_insights.used, executive_insights.max) + '%'}</div>
                    </div>
                  </span>
                ) : null}
              </div>
            )}
            { usageMeter && (user_plan == 'free' || user_plan == 'premium') ? (
              <div className='mt-2'>
                <p className="card-description"><small>{usageMeter.next_steps} <a href="/pricing">here</a> or buy additional insight credits <a href="/shop/insight_credit_packages">here</a>.</small></p>
              </div>
            ) : (
              <div className='mt-2'>
                <p className="card-description"><small>Buy additional insight credits <a href="/shop/insight_credit_packages">here</a>.</small></p>
              </div>
            )}
          </div>
        </div>
      </p>
    </div>
  );
}

export default AutonomousAiUsage;
